import { Editor } from 'tinymce'

const boxWidths = [100, 80, 60] as const;
const classPrefix = 'mds-w-';

export const registerBoxWidth = (editor: Editor) => {
	editor.ui.registry.addMenuButton('box-width', {
        icon: 'width',
        tooltip: 'Width',
        fetch: (cb) => {
			const bottomNode = editor.selection.getNode();
			const node = bottomNode.closest('.mds-box-format');
			if (!node) return;
			const setTypeClass = (width?: typeof boxWidths[number]) => {
				const addClass = width ? !node.classList.contains(classPrefix + width) : false;
				node.classList.remove(...boxWidths.map(w => classPrefix + w));
				if (addClass) node.classList.add(classPrefix + width);
				editor.dispatch('Change')
			};
			cb([
				{ 
					type: 'togglemenuitem', 
					value: 'auto', 
					text: 'auto', 
					onAction: () => setTypeClass(), 
					active: !node.className.includes(classPrefix) 
				},
				...boxWidths.map(w => ({ 
					type: 'togglemenuitem' as const, 
					value: 'mds-w-' + w, text: w + '%', 
					onAction: () => setTypeClass(w), 
					active: node.classList.contains('mds-w-' + w) 
				}))
			]);
		}
    })
}